export const commStore = {

    namespaced: true,
  
    state: () => ({
        //서버 요청 수
        serverCallCount: 0,
        isFotterShow: true
    }),  

    getters: {
        getServerCallCount(state){
            return state.serverCallCount;
        },
        getIsFotterShow(state){
            return state.isFotterShow
        }        
    },

    mutations: {        
        setServerCallCount(state, value){            
            state.serverCallCount += value;            
            if (state.serverCallCount < 0){
                state.serverCallCount = 0;
            }
        },        
        setIsFotterShow(state, value){
            state.isFotterShow = value;
        },
        clearServerCallCount(state){
            state.serverCallCount = 0;            
        }
    },

    actions: {
      
    }

};